import {Component, input, output, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule} from "@angular/forms"
import {MatButtonModule} from "@angular/material/button"
import {MatDialogModule} from "@angular/material/dialog"
import {MatInputModule} from "@angular/material/input"
import {LoadingSpinnerComponent} from "@app/common/components/progress"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-add-item-dialog",
    templateUrl: "./add-item-dialog.component.html",
    styleUrls: ["./add-item-dialog.component.scss"],
    imports: [MatInputModule, MatDialogModule, MatButtonModule, FormsModule, LoadingSpinnerComponent],
})
export class AddItemDialogComponent {
    readonly $title = input<string>("New item", {alias: "title"})
    readonly $confirmDisabled = input<boolean>(true, {alias: "confirmDisabled"})
    readonly $isLoading = input<boolean>(false, {alias: "isLoading"})
    readonly $confirmButtonText = input<string>("Create", {alias: "confirmButtonText"})

    readonly confirm = output<void>()
}
